import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { IonSpinner } from '@ionic/react'
import WorkOrderTableSection from '../components/WorkOrderTableSection'
import {
  MANAGER_INDEX_COLUMNS,
  MANAGER_INDEX_PAGE_SIZE,
  MANAGER_WORK_ORDER_LIST_COLORS,
  MANAGER_WORK_ORDER_STATUS_COLORS,
} from '../constants'
import { filterRowsByWorkOrderNumber } from '../filters'
import { selectors } from '../reducer'
import * as apiActions from 'api-actions'

const propTypes = {
  fetchManagerWorkOrders: PropTypes.func.isRequired,
  rows: PropTypes.array.isRequired,
  // Owned by the dashboard so the term survives switching between tabs.
  search: PropTypes.string,
}

function cellTextColor(row, columnKey) {
  if (columnKey === 'status') {
    return MANAGER_WORK_ORDER_STATUS_COLORS[row.statusKey]
  }
  if (columnKey === 'list') {
    return MANAGER_WORK_ORDER_LIST_COLORS[row.listKey]
  }
  return undefined
}

function WorkOrderIndex({ fetchManagerWorkOrders, rows, search = '' }) {
  const [isLoading, setIsLoading] = useState(rows.length === 0)

  useEffect(() => {
    let isActive = true
    setIsLoading(true)
    fetchManagerWorkOrders().finally(() => {
      if (isActive) setIsLoading(false)
    })
    return () => {
      isActive = false
    }
  }, [fetchManagerWorkOrders])

  const normalizedSearch = search.trim().toLowerCase()

  const filteredRows = useMemo(
    () => filterRowsByWorkOrderNumber(rows, normalizedSearch),
    [rows, normalizedSearch]
  )

  if (isLoading && rows.length === 0) {
    return (
      <div className="manager-dashboard__index manager-dashboard__loading">
        <IonSpinner name="crescent" aria-label="Loading work orders" />
      </div>
    )
  }

  if (filteredRows.length === 0) {
    return (
      <div className="manager-dashboard__index">
        <p className="manager-dashboard__no-results">
          {normalizedSearch
            ? 'No orders found matching your search'
            : 'No work orders found'}
        </p>
      </div>
    )
  }

  return (
    <div className="manager-dashboard__index">
      <WorkOrderTableSection
        columns={MANAGER_INDEX_COLUMNS}
        rows={filteredRows}
        viewType="index"
        pageSize={MANAGER_INDEX_PAGE_SIZE}
        getCellTextColor={cellTextColor}
        pageResetKey={normalizedSearch}
      />
    </div>
  )
}

WorkOrderIndex.propTypes = propTypes

function mapStateToProps(state) {
  return {
    rows: selectors.allWorkOrdersAsIndexRows(state),
  }
}

const mapDispatchToProps = {
  fetchManagerWorkOrders: apiActions.fetchManagerWorkOrders,
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderIndex)
